import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";

export function addEventReceipt(_event_id, _receipt) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure receipts is an array
                const receipts = Array.isArray(event.receipts)
                    ? event.receipts
                    : [];

                // prefer matching by permanent id first
                let idx = -1;

                if (_receipt?.id != null) {
                    idx = receipts.findIndex(r =>
                        r &&
                        r.id != null &&
                        String(r.id) === String(_receipt.id)
                    );
                }

                // fallback to temp_id
                if (idx < 0 && _receipt?.temp_id != null) {
                    idx = receipts.findIndex(r =>
                        r &&
                        r.temp_id != null &&
                        String(r.temp_id) === String(_receipt.temp_id)
                    );
                }

                if (idx >= 0) {
                    // update existing receipt; merge only defined fields
                    const base = receipts[idx];
                    const patch = _receipt;
                    const merged = { ...base };

                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") {
                            merged[k] = patch[k];
                        }
                    });

                    receipts[idx] = merged;
                } else {
                    // add new receipt
                    receipts.push(_receipt);
                }

                // write back
                event.receipts = receipts;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Receipt with ID ${_receipt.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventReceipt:", error);
            throw error;
        });
}

export function updateEventReceipt(_event_id, _receipt) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure receipts is an array
                const receipts = Array.isArray(event.receipts)
                    ? event.receipts.slice()
                    : [];

                // prefer matching by id
                const idx = receipts.findIndex(m =>
                    m &&
                    _receipt &&
                    m.id != null &&
                    _receipt.id != null &&
                    String(m.id) === String(_receipt.id)
                );

                if (idx >= 0) {
                    const { merged, changed } = mergeChanged(receipts[idx], _receipt);
                    if (changed) receipts[idx] = merged;
                } else {
                    // add new receipt if not found
                    receipts.push(_receipt);
                }

                // write back
                event.receipts = receipts;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Receipt with ID ${_receipt.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventReceipt:", error);
            throw error;
        });
}

export function deleteEventReceipt(_event_id, _receipt_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite"); // Use 'readwrite' mode for updates
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                const receipts = Array.isArray(event.receipts)
                    ? event.receipts
                    : [];

                // Filter out the receipt with the specified ID
                const updatedReceipts = receipts.filter(receipt => {
                    if (!receipt) return false;
                    return String(receipt.id) !== String(_receipt_id);
                });

                // Update the event with the modified receipts array
                event.receipts = updatedReceipts;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Receipt with ID ${_receipt_id} in Event with ID ${_event_id} deleted successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEventReceipt:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}

